module.exports = __webpack_public_path__ + "assets/img/offline-stripe.9cc02f28.svg";